import { WarningOutlined } from "@ant-design/icons";
import { useOidcUser } from "@axa-fr/react-oidc";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { logCustomMessage } from "../../../store/ui/uiActions";
import { StatusPage } from "./StatusPage";

export const ServiceWorkerNotSupportedComponent = () => {
  //
  const dispatch = useDispatch();
  const location = useLocation();
  const { oidcUser } = useOidcUser();

  //
  useEffect(() => {
    dispatch(
      logCustomMessage(
        "LogBrowserNotSupported",
        oidcUser?.sub,
        "Browser not supported",
        `userAgent: ${navigator.userAgent}`
      )
    );
  }, [oidcUser]);

  return (
    <StatusPage
      icon={<WarningOutlined />}
      tone="warning"
      title="This browser window can't keep you signed in"
      message="Private and incognito windows often block what sign-in needs. Open this page in a regular Chrome or Edge window."
      buttonLabel="Try again"
      onButtonClick={() => {
        var redirectPathname =
          location?.pathname === "/home" || location?.pathname === "/home/"
            ? "/"
            : "/home";

        dispatch({ type: "CLEAR_REDUX_STORE" });
        window.location.replace(
          `${process.env.REACT_APP_URI}${redirectPathname}`
        );
      }}
    />
  );
};
